/**
 * Timeline Task Helper Utilities
 * Functions for task classification and styling
 */

/**
 * Determines the CSS class name for a task based on its name
 * @param taskName - The name of the task
 * @returns The corresponding CSS class name
 */
export const getTaskClassName = (taskName: string): string => {
    const nameLower = taskName.toLowerCase();
    if (nameLower.includes('phone')) return 'phone-activity';
    if (nameLower.includes('chat')) return 'chat-activity';
    if (nameLower.includes('break')) return 'break-activity';
    return 'other-activity';
};
